<template>
    <div class="heading__right">
        <button v-if="showButtonCreate" class="heading__right_button" @click.prevent="clickCreateOrder">
            <span class="heading__right_button_text">{{ __t('O.CREATE_ORDER') }}</span>
        </button>
        <logo_user
            :key="'logo_user'"
        />
    </div>
</template>

<script>

import {createHelpers} from "vuex-map-fields";
import {screenSize} from "../../mixins/screenSize";
import logo_user from "./LogoUser.vue";
import burger_menu from "./BurgerMenu.vue";
import {includeCurrentUrlString} from "../../helpers/includeCurrentUrlString";
import {errorOutput} from "../../helpers/errorOutput";
import {__t} from "../../helpers/translate";

const {mapFields: mUser} = createHelpers({
    getterType: 'user/getUserField',
    mutationType: 'user/updateUserField',
})
const {mapFields: mCouriers} = createHelpers({
    getterType: 'couriers/getCouriersField',
    mutationType: 'couriers/updateCouriersField',
})
export default {
    name: "heading",
    components: {burger_menu, logo_user},
    mixins: [screenSize],
    data() {
        return {
            isOpenLogout: false,
            sectionName: '',
        }
    },
    beforeMount() {
        const headingRight = document.querySelector('.heading__right_template');
        if (headingRight) {
            headingRight.parentNode.removeChild(headingRight);
        }
        EventBus.$on('load_menu_main', this.loadMenu);
    },
    mounted() {
        this.$store.dispatch('user/STATE_LOAD_HEADING', false)
    },
    beforeUnmount() {
        EventBus.$off('load_menu_main', this.loadMenu);
    },
    methods: {
        loadMenu() {
            if (this.activeItemMenuMain) {
                this.sectionName = `${this.__t(this.activeItemMenuMain.const)}`;
            }
        },
        clickCreateOrder() {
            EventBus.$emit('create_new_courier');
        },
        getSelectLocationsId() {
            $api.get('/internal/aggregators/locations/id/select')
                .then(resp => {
                    if (resp.data) {
                        console.log('sel loc id', resp.data);
                        return resp.data;
                    } else {
                        errorOutput(__t('O.FAILED_GET_INFORMATION_ON_ACTIVE_LOCATIONS'), resp, 'getSelectLocationsId');
                    }
                })
                .catch(err => {
                    errorOutput(__t('O.FAILED_GET_INFORMATION_ON_ACTIVE_LOCATIONS'), err, 'getSelectLocationsId');
                })
        }
    },
    computed: {
        ...mUser([
            'menuMainItems',
            'activeItemMenuMain',
            'isLoadMenu',
            'isLoadPage',
        ]),
        ...mCouriers([
            'isNewCourier',
        ]),
        showHeading() {
            if (this.isMobileScreen) {
                return false;
            }
            return true;
        },
        showButtonCreate() {
            if (includeCurrentUrlString('courier') && !this.isNewCourier) {
                return true;
            }
            return false;
        }
    }
}
</script>
